import { getSelectedCategoryName } from '../helpers/get-selected-category-name.js';

function initializeBudget() {
	const categoryName = getSelectedCategoryName(this.formElement);

	const labelElement = this.currentStepElement.querySelector('.quote-request-budget-min-max');
	if (categoryName) {
		labelElement.dataset.originalText = labelElement.textContent;
		labelElement.textContent = `What is your budget range for the ${categoryName}?`;
	} else if (labelElement.dataset.originalText) {
		labelElement.textContent = labelElement.dataset.originalText;
	}
}

export {
	initializeBudget
}
